module.exports = __webpack_public_path__ + "img/glassquality_7.9e9faa68.png";